// the generator
function ReplaceWith(Ele) {
  'use-strict'; // For safari, and IE > 10
  var parent = this.parentNode,
      i = arguments.length,
      firstIsNode = +(parent && typeof Ele === 'object');
  if (!parent) return;

  while (i-- > firstIsNode){
    if (parent && typeof arguments[i] !== 'object'){
      arguments[i] = document.createTextNode(arguments[i]);
    } if (!parent && arguments[i].parentNode){
      arguments[i].parentNode.removeChild(arguments[i]);
      continue;
    }
    parent.insertBefore(this.previousSibling, arguments[i]);
  }
  if (firstIsNode) parent.replaceChild(Ele, this);
}
if (!Element.prototype.replaceWith)
    Element.prototype.replaceWith = ReplaceWith;
if (!CharacterData.prototype.replaceWith)
    CharacterData.prototype.replaceWith = ReplaceWith;
if (!DocumentType.prototype.replaceWith)
    CharacterData.prototype.replaceWith = ReplaceWith;


document.addEventListener("DOMContentLoaded", function() {

  if(document.body.classList.contains('sfPageEditor')
     || document.body.classList.contains('InEdit')) {
    console.log('abort tab generator')
    return;
  }

  const targets = document.querySelectorAll('[is=tabs]')
  let c = 0

  for (var i = 0; i < targets.length; i++) {

    let source = targets[i]
    let parent = document.createElement('div')
    parent.classList.add('tabs')
    let headers = document.createElement('div')
    headers.classList.add('headers')
    let content = document.createElement('div')
    content.classList.add('content')

    let children = source.children
    for (var child = 0; child < children.length; child++) {
      if (children[child].nodeName.length === 2 &&
        children[child].nodeName[0] === 'H') {
        // is a heading
        let _input = document.createElement('input')
        _input.id = 'tab-' + (++c)
        _input.setAttribute('type', 'radio')
        _input.setAttribute('name', 'tag-group-' + i)
        if (parent.children.length === 0) {
          _input.setAttribute('checked', 'checked')
        }
        parent.appendChild(_input)

        let _heading = document.createElement('label')
        _heading.setAttribute('tabindex', 0)
        _heading.setAttribute('for', 'tab-' + c)
        _heading.innerHTML = children[child].innerHTML
        if (children[child].classList.contains('bump'))
          _heading.classList.add('bump')
        _heading.addEventListener('keypress', function(event) {
          if (event.keyCode === 32) {
            document.getElementById(event.target.attributes['for'].value)
              .click();
            event.preventDefault();
          }
        })
        headers.appendChild(_heading)
      } else {
        let _i = children[child]
        if(children[child].nodeName !== 'SECTION') {
          _i = document.createElement('section')
          _i.appendChild(children[child])
        }
        content.appendChild(_i)
        child--;
      }
    }
    parent.appendChild(headers)
    parent.appendChild(content)
    source.replaceWith(parent)
  }

})



// WEBPACK FOOTER //
// ./theme/_base/js/tab-handler.js